export default __webpack_public_path__ + "static/media/countryway.5cfd54ea.jpeg";